export default "__VITE_ASSET__da16893b__"